import { render } from "./Lenh-Dien-Tu.vue?vue&type=template&id=5d9857ae&scoped=true"
import script from "./Lenh-Dien-Tu.vue?vue&type=script&lang=js"
export * from "./Lenh-Dien-Tu.vue?vue&type=script&lang=js"

import "./Lenh-Dien-Tu.vue?vue&type=style&index=0&id=5d9857ae&scoped=true&lang=css"
import "./Lenh-Dien-Tu.vue?vue&type=style&index=1&id=5d9857ae&lang=scss&scoped=true"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9857ae"]])

export default __exports__